module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Performance: Actual vs. Target","alert":"Provide values to see the plot"},"de":{"title":"Performance: Ist vs. Soll","alert":"Werte eingeben um die Grafik zu sehen"}}')
  delete Component.options._Ctor
}
